import axios from "axios";
export function getQueueList() {
  return new Promise((resolve, reject) => {
    axios.get("queue/list")
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  })
}